<script>
    import { getContext } from "svelte";
    import { createForm } from "svelte-forms-lib";
    import * as yup from "yup";
    import YupPassword from 'yup-password';
    YupPassword(yup);

    import {
        Alert,
        Card,
        Col,
        Container,
        Row,
        Spinner
    } from 'sveltestrap';
    
	import Password from "./Fields/Password.svelte";
    import Recaptcha from "./Fields/Recaptcha.svelte";

    import {navigate} from "svelte-routing"

    import { _ } from "svelte-i18n";

    export let token;

    let result = null;

    let apiUrl = getContext("apiUrl");

    const { form, errors, handleChange, isSubmitting, handleSubmit, isValid } = createForm({
        initialValues: {
            password: "",
            confirmePassword: "",
        },
        validationSchema: yup.object().shape({
            password: yup
                .string($_("components.Forms.errorMessage.string"))
                //.matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/, errorMessage.passwordContains)
                .password()
                .minLowercase(3, $_("components.Forms.errorMessage.password.minLowerCase"))
                .minUppercase(1,  $_("components.Forms.errorMessage.password.minUpperCase"))
                .minNumbers(1, $_("components.Forms.errorMessage.password.minNumbers"))
                .minSymbols(1, $_("components.Forms.errorMessage.password.minSymbols"))
                .minRepeating(3)
                .min(8, $_("components.Forms.errorMessage.min", {min:"8"}))
                .required($_("components.Forms.errorMessage.required")),
            confirmPassword: yup
                .string()
                .required($_("components.Forms.errorMessage.required"))
                .oneOf([yup.ref('password')], $_("components.Forms.errorMessage.password.notMatches")),
        }),
        onSubmit: async () => {
            var Form = new FormData(document.getElementById("changePasswordForm"))
            const res = await fetch(apiUrl + 'verifForgotPassword.php?token='+token, {
                method: 'POST',
                body: Form
            })
            
            const json = await res.json()
            result = json

            if(result.success) {
                setTimeout(() => { navigate("/", {replace: true}) }, 2500);
            }
        },
    });
</script>

<Container>
    <Row>
        <Col></Col>
        <Col>
            <Card body>
                {#if $isSubmitting}
                    <Spinner /> {$_("components.Forms.ChangePasswordForm.loading")} ...
                {/if}
                

                {#if result}
                    {#key result}
                        {#if result.error}
                            <Alert color="danger" dismissible>{result.error}</Alert>
                        {/if}
                        {#if result.success}
                            <Alert color="success" dismissible>{result.success}</Alert>
                        {/if}
                    {/key}
                {/if}

                <form on:submit|preventDefault={handleSubmit} id="changePasswordForm">
                    <Password 
                        name="password"
                        autocomplete="new-password"
                        label={$_("components.Forms.ChangePasswordForm.newPassword")}
                        feedback={$errors.password}
                        bind:value={$form.password}
                        on:change={handleChange}
                        on:blur={handleChange}
                    />
                    <Password 
                        name="confirmPassword"
                        autocomplete="new-password"
                        label={$_("components.Forms.ChangePasswordForm.confirmNewPassword")}
                        feedback={$errors.confirmPassword}
                        bind:value={$form.confirmPassword}
                        on:change={handleChange}
                        on:blur={handleChange}
                    />
                    <Recaptcha />
                    <div class="d-grid gap-2">
                        <input type="submit" disabled={!$isValid} class="btn btn-primary" value="{$_("components.Forms.ChangePasswordForm.updatePassword")}" />
                    </div>
                </form>
            </Card>
        </Col>
        <Col></Col>
    </Row>
</Container>